import { Maximize2, Minimize2 } from 'lucide-react';

import { useQueryBuilder } from '@/sections/insights/queryBuilder/state/useQueryBuilder';

export const QueryBuilderHeaderButtons = () => {
  const { isMaximized, toggleMaximized } = useQueryBuilder();

  return (
    <>
      <div className="flex flex-shrink-0 items-center gap-2">
        <button
          onClick={toggleMaximized}
          className="text-chariot-text-secondary hover:text-chariot-text-primary hover:bg-chariot-background-secondary rounded-md p-1 transition-colors"
          aria-label={
            isMaximized ? 'Exit maximized mode' : 'Maximize workspace'
          }
          data-testid="query-builder-maximize-toggle"
        >
          {isMaximized ? (
            <Minimize2 className="h-5 w-5" />
          ) : (
            <Maximize2 className="h-5 w-5" />
          )}
        </button>
      </div>

      {/* Screen reader announcements */}
      <div className="sr-only" role="status" aria-live="polite">
        {isMaximized
          ? 'Query Builder maximized'
          : 'Query Builder restored to normal view'}
      </div>
    </>
  );
};
